import styled from "styled-components";

export const SSettingsTopNavChevronRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--icon-03);
`;
